import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { format } from 'date-fns'
import { sortJsonByKey } from 'utils/utils.js'
const Diction = {
  mon: '월',
  tue: '화',
  wed: '수',
  thu: '목',
  fri: '금',
  sat: '토',
  sun: '일',
}
const dayArr = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']
const sortTaskByDay = function (a, b) {
  let firstDayArr = a['day']
  let secondDayArr = b['day']
  for (let i = 0; i < firstDayArr.length; ++i) {
    let firstIndex = dayArr.indexOf(firstDayArr[i])
    let secondIndex = dayArr.indexOf(secondDayArr[i])
    if (firstIndex > secondIndex) {
      return 1
    } else if (firstIndex < secondIndex) {
      return -1
    }
  }

  if (firstDayArr.length < secondDayArr.length) {
    return 1
  } else if (firstDayArr.length > secondDayArr.length) {
    return -1
  }

  if (a['no'] < b['no']) {
    return -1
  } else {
    return 1
  }
}
// 캠페인 투두 리스트
export default function ChallengeTodoList({ challengeInfo, todayTaskExist }) {
  const challengeStartDate = challengeInfo?.start_date
  let formattedTaskList = {}
  let taskListBySingleDate = []
  if (challengeInfo?.tasks) {
    const taskList = challengeInfo.tasks
    for (let i = 0; i < taskList.length; ++i) {
      const sDate = taskList[i]['start_date']
        ? format(new Date(taskList[i]['start_date']), 'M/d')
        : ''
      const eDate = taskList[i]['end_date'] ? format(new Date(taskList[i]['end_date']), 'M/d') : ''
      const taskKey = sDate === eDate ? `${sDate}` : `${sDate}~${eDate}`

      if (taskList[i]['task_date']) {
        taskListBySingleDate.push(taskList[i])
      } else if (formattedTaskList && formattedTaskList[`${taskKey}`]) {
        formattedTaskList[`${taskKey}`].push(taskList[i])
      } else {
        formattedTaskList[`${taskKey}`] = [taskList[i]]
      }
    }
  }
  formattedTaskList = sortJsonByKey(formattedTaskList, 'asc')
  /*


  */
  return (
    <TodoListWrapper>
      <TodoListTitle>루틴 인증</TodoListTitle>
      {Object.keys(formattedTaskList).map((key, index) => {
        //order by day
        const dateTaskList = formattedTaskList[key]
        dateTaskList.sort(sortTaskByDay)
        let dayTxt = null
        let dayCont = false
        console.log(key)
        return (
          <DateBox key={`campaign-todolist-date-${index}-${key}`}>
            <DateWrapper>
              <DateTitle>인증 기간</DateTitle>
              <DateTxt>{`${key}`}</DateTxt>
            </DateWrapper>
            {dateTaskList.map((task, taskIndex) => {
              let isCont = false
              if (task['day'].length > 3) {
                //checkContinuous
                let firstIndex = dayArr.indexOf(task['day'][0])
                let lastIndex = dayArr.indexOf(task['day'].slice(-1)[0])
                if (lastIndex - firstIndex + 1 === task['day'].length) {
                  isCont = true
                }
              }
              if (isCont === false) {
                let currDayTxt = []
                for (let i = 0; i < task['day'].length; ++i) {
                  currDayTxt.push(Diction[task['day'][i]])
                }
                currDayTxt = currDayTxt.join(',')
                if (dayTxt === currDayTxt) {
                  dayCont = true
                }

                dayTxt = currDayTxt
              } else {
                if (dayTxt === `${Diction[task['day'][0]]}~${Diction[task['day'].slice(-1)]}`) {
                  dayCont = true
                }
                dayTxt = `${Diction[task['day'][0]]}~${Diction[task['day'].slice(-1)]}`
              }
              return (
                <div key={`campaign-todolist-task-${task['no']}`}>
                  <TaskWrapper>
                    {index === 0 && taskIndex === 0 ? (
                      <TodoListNote>
                        👇내 인증탭에 자동 저장돼요!
                        <TodoListNoteBottomArrow></TodoListNoteBottomArrow>
                      </TodoListNote>
                    ) : null}
                    <TaskDay>{!dayCont ? dayTxt : null}</TaskDay>
                    <TaskItem>{`${task['title']}`}</TaskItem>
                  </TaskWrapper>
                </div>
              )
            })}
          </DateBox>
        )
      })}
      {
        taskListBySingleDate.length > 0 ? (
          <div>
            <DateWrapper>
              <DateTitle>특정 날짜 인증</DateTitle>
            </DateWrapper>
            <div>
              {taskListBySingleDate.map((task, index) => {
                return (
                  <div key={`campaign-todolist-single-date-task-${task['no']}`}>
                    <TaskWrapper>
                      <TaskDay>{format(new Date(task['task_date']), 'M/d')}</TaskDay>
                      <TaskItem>{`${task['title']}`}</TaskItem>
                    </TaskWrapper>
                  </div>
                )
              })}
            </div>
          </div>
        ) : null
        //taskListBySingleDate
      }
    </TodoListWrapper>
  )
}

const TodoListWrapper = styled.div`
  padding: 0 calc(100vw * (20 / 375));
`
const TodoListTitle = styled.h3`
  font-size: calc(100vw * (18 / 375));
  font-weight: bold;
  line-height: 1.11;
  margin-bottom: calc(100vw * (24 / 375));
`
const DateBox = styled.div``
const DateWrapper = styled.div`
  margin-bottom: calc(100vw * (15 / 375));
`
const DateTitle = styled.span`
  font-style: normal;
  font-weight: bold;
  font-size: calc(100vw * (16 / 375));
  line-height: calc(100vw * (23 / 375));
  color: #121212;
  margin-right: calc(100vw * (15 / 375));
`
const DateTxt = styled.span`
  font-style: normal;
  font-weight: 500;
  font-size: calc(100vw * (16 / 375));
  line-height: calc(100vw * (23 / 375));
  color: #4e4e4e;
`
const TaskWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: calc(100vw * (13 / 375));
  position: relative;
  padding-left: calc(100vw * (2 / 375));
`
const TaskDay = styled.div`
  flex: 0 1 auto;
  display: inline-block;
  font-style: normal;
  font-weight: 500;
  font-size: calc(100vw * (16 / 375));
  color: #121212;
  min-width: calc(100vw * (70 / 375));
`
const TaskItem = styled.div`
  flex: 1 1 auto;
  display: inline-block;
  padding: calc(100vw * (12 / 375)) calc(100vw * (20 / 375));
  background: #f7f7f7;
  border-radius: 10px;

  /*font style*/
  font-style: normal;
  font-weight: 500;
  font-size: calc(100vw * (14 / 375));
  color: #000000;
`
const TodoListNote = styled.div`
  position: absolute;
  top: calc(-100vw * (24 / 375));
  padding: calc(100vw * (8 / 375)) calc(100vw * (11.5 / 375));
  background: #ffffff;
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05), 0px 6px 16px rgba(0, 0, 0, 0.08),
    0px 3px 6px -4px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  font-size: calc(100vw * (12 / 375));
  right: calc(100vw * (-7 / 375));
`
const TodoListNoteBottomArrow = styled.div`
  position: absolute;
  width: calc(100vw * (10 / 375));
  height: calc(100vw * (10 / 375));
  bottom: calc(-100vw * (3 / 375));
  background: white;
  transform: rotate(45deg);
`
